<template>

</template>

<script>
export default {
  name: 'SalesPrediction',
};
</script>

<style scoped>

</style>
